import { FetchAPI } from '../Main/fetchAPI';
import { USER } from '../constants';

export const Authorization = {
	getAuthorizationTypes: () =>
		FetchAPI.getJson({
			urlStr: `${USER}/authorization-types`,
		}),
};
